import { HttpResponse } from "@angular/common/http";
import { Component } from "@angular/core";
import { StdioNull } from "child_process";
import { Subscription } from "rxjs";
import { Constants } from "src/app/app.constants";
import { AppService } from "src/app/app.service";
import { CommonService } from "src/app/common.service";
import { AttendanceConstant } from "../attendance.constant";
import { AttendanceService } from "../attendance.service";

declare var moment: any;
declare var $: any;
@Component({
    selector: 'app-leave-summary',
    templateUrl: './leave-summary.component.html',
    styleUrls: ['./leave-summary.component.css']
})

export class LeaveSummaryComponent{
    constructor(
        private attendanceService: AttendanceService,
        private appService: AppService,
        private commonService: CommonService

    ){
        
    }

    userLeaveSummaries: any[] = [];
    listOfMonths: any[] = [];
    isLoader: boolean = false;
    imageBaseUrl: string = Constants.IMAGE_BASE_URL;

    attendanceTypeList: any[] = [];
    attendanceTypeMap: any = {}
    attendanceTypeSubscription: Subscription;
    totalTeamMembers:Number;
    attendanceStatusMap: any = AttendanceConstant.ATTENDANCE_STATUS_MAP;
    fieldUserSearch : string = null
    filteredData: { count: number, filteredList: any[] } = { count: 0, filteredList: [] };
    searchableHeaderKeys: any[] = ["name"];
    customFieldFilterObject: any = {};
    selcteduserFilterList : any[]=[];
    userList : any[]=[];

    selectedYear :any;


    async ngOnInit(){

        this.attendanceTypeSubscription = this.attendanceService.attendanceTypeSubject.subscribe((data)=>{
            if(data){
                var attendanceTypeList = data.list;
                if(attendanceTypeList && attendanceTypeList.length>0){
                    for(let obj of attendanceTypeList){
                        if(obj.isApplicable){
                         this.attendanceTypeList = [...this.attendanceTypeList,obj];
                         // this.leaveTypeListWithFlag.push(obj)
                        }
                    }
                }
               
                this.attendanceTypeMap = data.map;
            }
        })

        this.listOfMonths = Array.apply(0, Array(12)).map(function(_,i){return moment().month(i).format('MMM')});
        this.getYear();
        //this.selectedYear =  moment();
        this.getLeaveSummary();
    }

    ngAfterContentInit(){
        $(".content").mCustomScrollbar();
    }

    getLeaveSummary(timestamp?){
        this.isLoader = true;
        this.attendanceService.getLeaveSummary(timestamp)
            .subscribe((res: HttpResponse<any>) =>{
                this.isLoader = false;
                // console.log(res.body);
                this.userLeaveSummaries = res.body.userLeaveSummaries;
                for(let obj of this.userLeaveSummaries){
                    // this.userList.push(obj.userInfo)
                    obj["user_id"] = obj.userInfo.id;
                    obj["name"] = obj.userInfo.name;
                    // obj["checked"] = false;
                }
                this.totalTeamMembers = this.userLeaveSummaries.length;
                this.enableTooltip("tip2")
                // console.log( this.userList)
            }, (err)=>{
                this.isLoader = false;
            })
    }

    enableTooltip(elemSelector){
        this.appService.enableTooltip(elemSelector);
    }

    getLeaveListForMonth(leavesByType){
        let list = [];
        if(leavesByType && Object.keys(leavesByType).length>0){
            for(let key of  Object.keys(leavesByType)){
                // list.push(leavesByType[key])
               
                list.push.apply(list, leavesByType[key])
            }
        }
        // console.log(list);
        var uniq = {}
        list = list.sort((a, b) => { return a.fromTimestamp - b.fromTimestamp})
        list = list.filter(obj => !uniq[obj.leaveType] && (uniq[obj.leaveType]  = true));
        
        return list;
    }

    getLeaveColor(leave){
        if(leave && this.attendanceTypeMap && this.attendanceTypeMap[leave.leaveType]){
            return this.attendanceTypeMap[leave.leaveType].colorCode;
        }
        return "";
    }

    getShortName(userInfo){
        if(userInfo && userInfo.name){
            let shorName = this.commonService.nameSorting(userInfo.name);
            if(shorName){
                return shorName;
            }
        }
        return "";
    }

    getShortNameColor(userInfo){
        if(userInfo){
            let colorArray = Constants.RANDOM_COLOR_CLASS;
            let i = userInfo.id % colorArray.length;
            return colorArray[i];
        }
        return "";
       
    }
    userfilter(userObect){

       let selectedUser =[]
       var index = null;
       if(userObect.checked){
        userObect.checked = true;
       }else{
        userObect.checked = false;  
       }
        for (index in this.userLeaveSummaries) {
            if (this.userLeaveSummaries[index].checked) {
              selectedUser.push(this.userLeaveSummaries[index].user_id);
            }  
    }

    if (selectedUser.length > 0) {
        this.customFieldFilterObject['user_id'] = selectedUser;
      } else {
        delete this.customFieldFilterObject['user_id'];
      }
      this.selcteduserFilterList = selectedUser
      this.customFieldFilterObject = Object.assign({}, this.customFieldFilterObject);
    //   console.log(this.userLeaveSummaries)
    }
    yy: number;
    years: any [] = [];
    selectedYearStr : any = '2022';
    getYear(){
      var today = new Date();
      this.yy = today.getFullYear();        
      for(var i = (this.yy-1); i <= this.yy; i++){
      this.years.push(i);}
    }

    changeYear(year){
        
       this.selectedYearStr = year;
       let yearToTimestamp = new Date().setFullYear(year, 0, 10);
       this.selectedYear = yearToTimestamp/1000|0;
      // console.log((this.selectedYear))
        this.getLeaveSummary(this.selectedYear);

      }
   
}